// extracted by mini-css-extract-plugin
module.exports = {"member":"GroupMember_style_member__1LybH"};